import { publicClient, privateClient } from './client';
import { AssociatedPromotion } from './AssociatedPromotion';

const transactionsAssociatedPromotion = (pub: boolean) => new AssociatedPromotion(pub ? publicClient : privateClient);
export default transactionsAssociatedPromotion;
